import { useAppDispatch } from '../../hooks/redux';
import { setFlyoutTemplate, toggleFlyout } from '../../store/slices/flyout.slice';
import { FlyoutTemplate } from '../../models/flyout.model';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import { useMemo } from 'react';
import { URLS_WITH_NO_PROFILE_NAME_REDIRECT } from '../widgets/widget-constants';
import { useCompareUrlWithProjectId } from 'common/hooks/route';

export default function ProfileCell({ dataItem, selectedTab, isTeamMember, isParent }: any) {
  const dispatch = useAppDispatch();
  const { compareUrl } = useCompareUrlWithProjectId();
  const textValue = !isTeamMember ? dataItem.profile : dataItem.fieldTeam;
  const isClickable = useMemo(() => {
    if (compareUrl(URLS_WITH_NO_PROFILE_NAME_REDIRECT, { endsWith: true })) {
      return false;
    }
    return Boolean((isParent && isTeamMember) || dataItem.profileId);
  }, [isParent, isTeamMember, dataItem, compareUrl]);

  return (
    <td
      className="profile-cell"
      style={{ cursor: isClickable ? 'pointer' : 'default' }}
      onClick={() => {
        if (!textValue) {
          return;
        }
        if (!isClickable) return;

        if ((!isTeamMember && dataItem.profileId) || (isTeamMember && dataItem.fieldTeamId)) {
          dispatch(
            setFlyoutTemplate({
              flyoutId: FlyoutTemplate.PROFILE_VIEW,
              flyoutParameters: {
                isTeamMember: isTeamMember,
                profileId: isTeamMember ? dataItem.fieldTeamId : dataItem.profileId,
                profileName: isTeamMember ? dataItem.fieldTeam : dataItem.profile,
                selectedTab: selectedTab,
                ...(isTeamMember
                  ? {
                      territoryId: dataItem.territoryId,
                    }
                  : {}),
              },
            })
          );
          dispatch(toggleFlyout(true));
        }
      }}
    >
      {textValue && (
        <div className="flex-row space-between">
          {textValue}
          {isClickable && <KwelloSvgIcon icon={KWELLO_ICON.CHEVRON_FILLED} />}
        </div>
      )}
    </td>
  );
}
